<template>
  <b-modal
    :id="`modal-edit-rule-${ruleId}`"
    :title="`${this.$t('menu.settings.alertsNewsletters.editRule')}`"
    size="xl"
    @show="showModal"
  >
    <edit-rule :ruleId="ruleId" :rule="myRule" />
    <template v-slot:modal-footer>
      <div>
        <button class="btn btn-secondary" @click="hideModal">
          {{ $t('menu.settings.alertsNewsletters.cancel') }}
        </button>
        <button
          class="btn btn-primary"
          v-if="alertRulesFooter"
          @click="updateMyRule"
        >
          {{ $t('menu.settings.alertsNewsletters.save') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import swal from 'sweetalert';
import editRule from '../../organisms/settings/settings-alert-rules/edit-rule';

export default {
  props: ['ruleId', 'rule'],

  components: {
    editRule,
  },

  data: () => ({
    loading: true,
    myRule: null,
    errorMessage: null,
  }),

  computed: {
    ...mapState('settings', ['companyAllUsers', 'alertRulesFooter']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  mounted() {
    // this.myRule = null;
    // this.myRule = {
    //   ...this.rule,
    // };
    // this.loading = false;
  },

  methods: {
    ...mapActions('alertRules', ['updateRule', 'setList']),

    hideModal() {
      this.$bvModal.hide(`modal-edit-rule-${this.ruleId}`);
    },

    async updateMyRule(event) {
      if (this.validateFields()) {
        await this.updateRule({
          token: this.userAuth.token,
          id: this.myRule._id,
          data: { ...this.myRule },
        });

        await this.setList({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
        });

        await swal(
          this.$t('menu.settings.alertsNewsletters.messages.updateRule.title'),
          this.$t(
            'menu.settings.alertsNewsletters.messages.updateRule.description',
          ),
          'success',
        );

        this.$bvModal.hide(`modal-edit-rule-${this.ruleId}`);
      } else {
        event.preventDefault();
        swal(
          this.$t(
            'menu.settings.alertsNewsletters.messages.enterNameRule.title',
          ),
          this.errorMessage,
          'error',
        );
      }
    },

    showModal() {
      this.loading = true;

      this.myRule = null;

      this.myRule = {
        ...this.rule,
      };

      this.setList({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
      });

      this.loading = false;
    },

    addNewEmail() {
      this.myRule.rules.push({
        email: null,
        justComment: false,
        alerts: [
          { grade: 0, value: false },
          { grade: 1, value: false },
          { grade: 2, value: false },
          { grade: 3, value: false },
          { grade: 4, value: false },
          { grade: 5, value: false },
          { grade: 6, value: false },
          { grade: 7, value: false },
          { grade: 8, value: false },
          { grade: 9, value: false },
          { grade: 10, value: false },
        ],
      });
    },

    removeEmail(index) {
      if (this.myRule.rules.length > 1) {
        this.myRule.rules.splice(index, 1);
      }
    },

    validateFields() {
      if (!this.myRule.name) {
        this.errorMessage = this.$t(
          'menu.settings.alertsNewsletters.messages.enterNameRule.description',
        );
        return false;
      }

      const validate = true;

      if (!validate) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.emails-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .input-email {
    flex: 1;
  }

  .grade-checkbox-section {
    display: flex;
    align-items: center;
  }

  .grade-checkbox {
    width: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-edit-rule/index.vue